// Navbar React Typescript Components
// by Michele Ursino
// (c) 2015 by Leica Geosystem, All Rights Reserved
// ===============================================================================

// ===================== <Navbar> ================================================

import $ from 'jquery';
import * as React from 'react';
import classNames from 'classnames';
import * as Bootstrap from 'bootstrap';
import * as _ from 'lodash';
import moment from 'moment';

import * as site from './tvgsite';
import * as tvgui from './popup';
import { RouteComponentProps } from 'react-router';
import { RouterContext } from '../lib/RouterContext';
import { handleLoginWithReturnUrl, handleLogout } from '../lib/session';

import Icon from './icon';

[ Bootstrap ] ; // Make sure Bootstrap get loaded even though is used implicitly

// ========================== <AboutBox> =========================================

/**
 * @internal
 */
interface AboutBoxProps {
  dict: site.LocaleDictionary;
  show: boolean;
  version: string;
  onShow: ( sf: boolean ) => void;
  license: site.License | site.ServiceLicense;
}

/**
 * @internal
 */
interface AboutBoxState {
  show?: boolean;
}

/**
 * @internal
 */
export class AboutBox extends React.Component< AboutBoxProps, AboutBoxState > {

  constructor( p: AboutBoxProps ) {
    super(p);
    this.state = { show: p.show };
  }

  componentWillReceiveProps( np: AboutBoxProps ) {
    this.setState({ show: np.show });
  }

  handleShowCredits(e) {
    $('#leicacopy').animate({ scrollTop: 190 }, 1000); // .scrollTop(150);
    e.stopPropagation();
  }

  handleHide() {
    $('#leicacopy').scrollTop( 0 ); // .scrollTop(150);
    this.setState({ show: false });
    if ( this.props.onShow )
      this.props.onShow(false);
  }

  render() {
    const { dict, license } = this.props;
    const year = moment().year();
    const bxClass = classNames({
      show:  this.state.show
    });
    const bkClass = classNames({
      'modal-backdrop': true,
      'in': this.state.show
    });
    const versionStr = dict ? dict['version'] : 'Version';
    let logoImage = site.isService( license )  ? '/images/truview-cloud-full.svg' : '/images/truview-enterprise-full.svg';
    return (
      <div id="copybackdrop" className={bkClass} onClick={this.handleHide.bind(this)}>
        <div id="leicacopy" className={bxClass} >
          <div className="info">
            <img alt="Brand" src={logoImage} />
            <h4>{versionStr} {this.props.version}</h4>
            <h4>&copy; {year} <a href="http://www.leica-geosystems.com" target="_blank">Leica Geosystems</a></h4>
            <p>When it has to be <span className="leica">right</span></p>
            <p>
              <span id="credits" onClick={this.handleShowCredits.bind(this)}>
                <i className="fa fa-arrow-down"></i> Credits <i className="fa fa-arrow-down"></i>
              </span>
            </p>
          </div>
        </div>
      </div>);
  }
}



// ============================ <Navbar> ===================================================

/**
 * @internal
 */
interface NavbarProps {
  user : site.UserInfo;
  allowChangePortal?: boolean;
  children?: any; //React.ReactElement<any>[];
  version: string;
  onUserHasChanged?: (u: site.UserInfo) => void;
  license: site.License | site.ServiceLicense;
  ref?: string | ((component: Navbar) => any);
  dict? : site.LocaleDictionary;
  info? : JSX.Element;
  showPortals?: boolean;
  updating?: boolean;
}

/**
 * @internal
 */
interface  NavbarState {
  info? : JSX.Element;
   children?: any; // React.ReactElement<any>[];
  showabout?: boolean;
  portalsOpen?: boolean;
  allowChangePortal?: boolean;
}

type NavbarBaseProps = NavbarProps & RouteComponentProps<any>;

/**
 * @internal
 */
class NavbarBase extends React.Component< NavbarBaseProps, NavbarState > {

  _logos: JSX.Element[] = [];

  _styles: tvgui.StyleMap = {
    'portalName': {
      display: 'inline-block',
      minWidth: '100px',
      maxWidth: '180px',
      overflowX: 'hidden',
      overflowY: 'visible',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      float: 'left',
      lineHeight: '20px'
    },
    'dropButton': {
      verticalAlign: 'middle',
      float: 'right',
      lineHeight: '16px'
    }
  };

  constructor(props: NavbarBaseProps) {
    super(props);
    this.state = {
      children: props.children || [ <span key="placeholder"/> ],
      showabout: false,
      portalsOpen: false,
      allowChangePortal: props.allowChangePortal === undefined ? false : props.allowChangePortal
    };
  }

  get height() : number {
    return 50;
  }

  componentWillReceiveProps( newprops: NavbarBaseProps ) {
    this.setState({ info: newprops.info, children : newprops.children });
  }

  componentWillMount() {
    let { license } = this.props;
    let branding = ( license && site.isService( license ) ) ? Icon.renderBranding( 'truviewCloudFull' ) : Icon.renderBranding('truviewEnterpriseFull' );
    this._logos.push( <li className="nav-bar" id="leicaLogo" key="leicalogo">
                        <div className="logo-frame" onClick={this.handleShowAbout.bind(this)}>
                          <img  alt="Leica Geosystems" src="/images/leica_sm.png"/>
                        </div>
                      </li>);

    this._logos.push( <li className="nav-bar hidden-md hidden-lg" key="tvlogomin" id="tvlogomin">
                        <a className="navbar-brand" href="/locations">
                          { Icon.renderBranding( 'truviewLogo' ) }
                        </a>
                      </li>);

    this._logos.push( <li className="nav-bar hidden-xs hidden-sm" key="tvlogo" id="tvlogo">
                        <a className="navbar-brand" href="/locations">
                          { branding }
                        </a>
                      </li>);
  }

  handleChangePortal( portalId: string ) {
    const { user, onUserHasChanged } = this.props;
    var newActivePortal = _.find( user.portals, (p) => p.id === portalId );
    if ( newActivePortal && newActivePortal.id !== user.portal.id ) {
      user.portal = newActivePortal;
      if ( onUserHasChanged )
        onUserHasChanged(user); // This call will save the user to the server.
      /*
      site.saveUserInfo(user.id, user )
      .then( ( u: site.UserInfo ) => {
        if ( onChangeUser)
          onChangeUser(u);
      })
      .fail( ( err: Error )=> {
        alert(err.message);
      });
      */
    }
  }

  handleShowAbout() {
    this.setState({showabout:true});
  }

  renderMenu() {
    const { dict, user, license } = this.props;
    var menu : JSX.Element[] = [];
    let serverType = site.isService( license ) ? 'Cloud' : 'Enterprise';
    if ( user ) {
      menu.push( <li className="nav-bar hidden-xs hidden-sm" key="settings" id="nb_settings">
        <div className="navbar-text"
             onClick={() => this.props.history.push(`/user/${user.id}`)}
             title={dict['settings'].title}>
            <i className="fa fa-user"></i> {dict['settings'].name}
        </div>
      </li>);

      menu.push( <li className="nav-bar hidden-xs hidden-sm" key="help" id="nb_help">
        <div className="navbar-text"
             id="scanTitle"
             title={dict['help'].title.replace('Global', serverType)}
             onClick={() => this.props.history.push('/help')}>&nbsp;<i className="fa fa-question-circle"></i>&nbsp;</div>
      </li>);

      menu.push( <li className="nav-bar hidden-xs hidden-sm" key="logout"  id="nb_logout">
        <div className="navbar-text"
             title={`${dict['logout'].title.replace('Global', serverType)} - ${user.firstname} ${user.lastname} `}
             onClick={handleLogout} data-testid="Navbar-logout">&nbsp;<i className="fa fa-power-off">&nbsp;</i>
        </div>
      </li>);

      menu.push( <li className="nav-bar hidden-md hidden-lg dropdown" key="usermenu" id="nb_usermenu">
        <div className="navbar-text">
          <a href="#" className="dropdown-toggle" data-toggle="dropdown" id="userMenuBt"
            aria-haspopup="true" aria-expanded="false">
            <i className="fa fa-bars"></i>
          </a>
          <ul className="dropdown-menu pull-right" role="menu" aria-labelledby="userMenuBt">
            <li className="dropdown-menu-item">
              <a href={ `/user/${user.id}`} title={dict['settings'].title} id="nb_menu_user">
                <i className="fa fa-user"></i> {dict['settings'].name}</a>
              </li>
            <li className="dropdown-menu-item">
              <a href="/admin" title={dict['admin'].title} id="nb_menu_admin">
                <i className="fa fa-cogs"></i> {dict['admin'].name}
              </a>
            </li>
            <li className="dropdown-menu-item">
              <a href="/help" target="_blank" title={dict['help'].title} id="nb_menu_help" >
                <i className="fa fa-question-circle"></i> {dict['help'].name}
              </a>
            </li>
            <li className="dropdown-menu-item">
              <a
                href="#"
                onClick={handleLogout}
                title={`${dict['logout'].title} - ${user.firstname} ${user.lastname} `}
                id="nb_menu_logout"
                data-testid="Navbar-logout"
              >
                <i className="fa fa-power-off"></i> {dict['logout'].name}
              </a>
            </li>
          </ul>
        </div>
      </li>);
    }
    else {
      if (this.props.match.path !== '/welcome') {
        menu.push( <li className="nav-bar" key="logout" >
          <div className="navbar-text" id="dropdown">
            <a href="#" title="Log-in TruView" id="nb_login" onClick={handleLoginWithReturnUrl}>
              <i className="fa fa-power-off"></i> Log In
            </a>
          </div>
        </li>);
      }
    }
    return menu;
  }

  renderAdminMenu() {
    const { user, dict, showPortals, updating, license } = this.props;
    if ( !user )
      return [];

    let adminMenu : JSX.Element[] = [];
    let portalMenuBtClass = classNames({
      'dropdown-toggle': true,
    });
    let portalIconClass = classNames({
      'fa': true,
      'fa-cube': !updating,
      'fa-refresh fa-spin': updating
    });

    if ( user && showPortals && user.portals && user.portal ) {
      if ( user.portals.length > 1 && this.state.allowChangePortal ) {
        const portalsLi = _.map( _.sortBy( user.portals, pr => pr.name) ,
          (p,idx) => <li key={idx} className={ user.portal.id === p.id ? 'dropdown-menu-item active' : 'dropdown-menu-item'} id={`nb_portal_${idx}`} >
                      <a href="#" onClick={ () => this.handleChangePortal(p.id)}>
                        <i className="fa fa-cube"></i> {p.name}
                      </a>
                    </li>);
        adminMenu.push( <li className="nav-bar  dropdown" key="portal">
          <div className="navbar-text">
            <a href="#" className={portalMenuBtClass} data-toggle="dropdown" id="userPortalBt"
                        aria-haspopup="true" aria-expanded="false">
              <i className="fa fa-chevron-down" style={this._styles['dropButton']}></i>
              <span style={this._styles['portalName']}>
                <i className={portalIconClass}></i> {user.portal.name}
              </span>
            </a>
            <ul className="dropdown-menu pull-right" role="menu" aria-labelledby="userPortalBt">
              {portalsLi}
            </ul>
          </div>
        </li>);
      }
      else {
        adminMenu.push( <li className="nav-bar  dropdown" key="portal">
          <div className="navbar-text" onClick={ () => this.props.history.push('/locations')}>
            <span style={this._styles['portalName']}>
              <i className={portalIconClass}></i> { user.portal.name}
            </span>
          </div>
        </li>);
      }
    }
    if ( user && ( user.role === 'admin' /*|| user.role === 'poweruser'*/ ) ) {
      let title;
      if ( site.isService( license ) ) {
        title = dict['admin'].title.replace('Global', 'Cloud');
      }
      else {
        title = dict['admin'].title.replace('Global', 'Enterprise');
      }
      adminMenu.push( <li className="nav-bar hidden-xs hidden-sm"
                          key="adminmenu"
                          title={title}
                          id="nb_admin"
                          onClick={() => this.props.history.push('/admin')}>
                      <div className="navbar-text">
                          <i className="fa fa-cogs"></i> {dict['admin'].name}
                      </div>
                    </li>);
    }
    return adminMenu;
  }


  render() {
    let self = this;
    const info : JSX.Element = <div className="info">{this.state.children}</div>;
    const navbarBranding = (<ul className="nav navbar-nav nav-bar-left">
                            {this._logos}
                          </ul>);
    const navbarMenu = (<ul className="navbar-nav nav-bar-right pull-right">
                        {this.renderAdminMenu()}
                        {this.renderMenu()}
                      </ul>);
    return (<nav className="navbar navbar-default navbar-inverse" role="navigation" data-testid={this.props.user ? 'LoggedIn' : 'LoggedOut'}>
              <AboutBox dict={this.props.dict} version={this.props.version}
                        show={this.state.showabout}
                        onShow={ (sf) => self.setState({showabout:sf})}
                        license={this.props.license}/>
              <div className="container-fluid" style={ { paddingLeft: '0px' } }>
                <div className="navbar-header">
                  {navbarMenu}
                  {navbarBranding}
                  {info}
                </div>
              </div>
            </nav>);
  }
}

/**
 * @internal
 */
export default class Navbar extends React.Component<NavbarProps> {
  render() {
    const {props} = this;
    return (
      <RouterContext>
        {(routeProps) => <NavbarBase {...props} {...routeProps} />}
      </RouterContext>
    );
  }
}
